module.exports = __webpack_public_path__ + "static/w22-a03b52c5d36a12eefb898c167dc182e0.jpg";